import type { JSX } from 'react'

export const MuteIcon = (): JSX.Element => (
  <use href='#muteIcon' height='100%' width='100%' />
)
